import React, { useEffect } from "react";
import Banner from "../components/Banner";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
const Events = () => {
  useEffect(() => {
    AOS.init({
      duration: 600, // Animation duration
      easing: "ease-in-sine", // Animation easing
    });
  }, []);

  return (
 <>
   <Helmet>
       <title>
        Yacht Rental for Events in Dubai | Yacht Party Events
       </title>

       <meta name="description" content="Host unforgettable yacht party events in Dubai with BlueHarbour. Perfect for birthdays, corporate events, and celebrations aboard luxury yachts with stunning views." />

       <meta
           name="keywords"
           content="Yacht rental dubai, Dubai yacht rental, Yacht rental dubai marina, Yachts rental dubai, Luxury yacht rental dubai, Yachts rental dubai price, Yacht rentals in dubai, Dubai yacht rentals, Party yacht rental dubai, Small yacht rental dubai, Private yacht rental dubai, Dubai yacht rental prices, Luxury yacht rental in dubai, Birthday yacht rental dubai, Yacht rental dubai for birthday, Yacht rental dubai new year’s eve, Yacht rental dubai party, Yacht rental in dubai prices, Best yacht rental dubai, Dubai marina yacht rental, Yacht rental marina dubai price, Dubai luxury yacht rental, Yacht rental dubai for couples, Luxury yacht rental dubai marina"
         />
     </Helmet>
    <main id="events">
      <Banner img="assets/images/events.jpg" text="Yacht Rental Dubai for Party Event" />

      <section className="section-1">
        <div className="container">
          <div className="row gx-0">
            <div className="col-lg-6 my-auto" data-aos="fade-right">
              <div className="text-wrapper pe-lg-5">
                <h2 className="text-start">CORPORATE EVENT</h2>
                <p>
                  <b>Host premium Corporate Yacht Events In Dubai</b>
                </p>
                <p>
                  Looking for the perfect location for a formal meeting,
                  networking mixer, or to celebrate company milestones? Blue
                  Harbour blends business with leisure through seamless
                  corporate yacht events in Dubai.
                </p>
                <p>
                  With skyline views, tailored décor, curated menus, and smooth
                  onboard service, we create corporate yacht parties in Dubai
                  that are both productive and unforgettable.
                </p>
                <p>
                  Ready to elevate your next gathering? Choose yacht rentals for
                  corporate events with Blue Harbour — it’s time to impress
                  beyond the boardroom.
                </p>
                <p>
                  <b>
                    <i>
                      In a city known for doing things differently, hosting your
                      event on a yacht isn’t just impressive — it’s iconic.
                    </i>
                  </b>
                </p>
              </div>
            </div>
            <div className="col-lg-6 mb-lg-0 mb-3">
              <img src="assets/images/f95ff0f0eb.jpg" alt="" />
            </div>

            <div className="col-lg-6 mb-lg-0 mb-3">
              <img src="assets/images/7xmxyz231206.jpg" alt="" />
            </div>
            <div className="col-lg-6 my-auto ps-lg-5" data-aos="fade-left">
              <div className="text-wrapper">
                <h2 className="text-start">BIRTHDAY PARTY</h2>
                <p>
                  <b>Yacht Rental for Birthday Party in Dubai</b>
                </p>
                <p>
                  Looking for the most memorable yacht birthday party in Dubai?
                  Trust Blue Harbour to make it happen.
                </p>
                <p>
                  Blue Harbour offers the perfect birthday party yacht rental in
                  Dubai for those looking to celebrate in luxury. Whether it’s
                  an intimate gathering or a lively bash, we provide premium
                  yacht rentals for birthday parties tailored to your style.
                </p>
                <p>
                  Enjoy an easy booking with our dedicated team. From
                  personalized decoration and delicious catering to music and
                  watersports, every detail is designed to make your day
                  unforgettable. Experience a one-of-a-kind birthday celebration
                  on a yacht in Dubai, with stunning skyline views and peaceful
                  waters.
                </p>
                <p>
                  <b>
                    <i>
                      Book your yacht today and celebrate your most luxurious
                      birthday yet!
                    </i>
                  </b>
                </p>
              </div>
            </div>

            <div className="col-lg-6 my-auto" data-aos="fade-right">
              <div className="text-wrapper pe-lg-5">
                <h2 className="text-start">PROPOSAL EVENT</h2>
                <p>
                  <b>Plan the perfect proposal on a yacht in Dubai.</b>
                </p>
                <p>
                  Ready to pop the question in the most unique way? Create
                  magical moments with proposals on a yacht in Dubai with Blue
                  Harbour- where love meets luxury on the water.{" "}
                </p>
                <p>
                  Choose a proposal on a luxury yacht in Dubai, complete with
                  romantic decor, stunning sunset backdrops, and your favourite
                  music. Whether it's an intimate setting or an elaborate
                  surprise, we help you make a one-of-a-kind proposal on a
                  luxury yacht for your story.
                </p>
                <p>
                  Planning an engagement on a yacht has become effortless with
                  our team, who handle every detail with precision- from florals
                  and candles to photography and fine dining.
                </p>
                <p>
                  There's nothing like a romantic yacht proposal under the Dubai
                  skyline. Write your love story in style with Blue Harbour-
                  surrounded by the sea, the stars and the person who matters
                  most.
                </p>
                <p>
                  <b>
                    <i>Say yes to the moment. Say yes with Blue Harbour.</i>
                  </b>
                </p>
              </div>
            </div>
            <div className="col-lg-6 mb-lg-0 mb-3">
              <img
                src="assets/images/proposal_book_my_sailing_yacht.jpg"
                alt=""
              />
            </div>

            <div className="col-lg-6 mb-lg-0 mb-3">
              <img src="assets/images/get-together.webp" alt="" />
            </div>
            <div className="col-lg-6 my-auto ps-lg-5" data-aos="fade-left">
              <div className="text-wrapper">
                <h2 className="text-start">GET TOGETHER</h2>
                <p>
                  <b>Host The Perfect Yacht Get-Together In Dubai</b>
                </p>
                <p>
                  Looking to bring your favourite people together to enjoy a
                  view like no other? Blue Harbour offers luxury yachts for
                  get-togethers in Dubai, where the open sea and the skyline set
                  the mood.
                </p>
                <p>
                  Whether it’s a lively catch-up with friends or an intimate
                  family yacht get-together in Dubai, we ensure every detail is
                  perfect- from onboard catering and music to water activities
                  and cruising past iconic landmarks like Burj Al Arab.
                </p>
                <p>
                  You don’t always need a reason, sometimes, the best memories
                  are made just because. A calm day on the water, good friends,
                  and the magic of Dubai is all you need to relax, laugh and
                  reconnect.
                </p>
                <p>
                  <b>
                    <i>
                      Planning a friend’s get-together event on a yacht? Blue
                      Harbour makes every outing an experience- luxurious,
                      stylish and soaked in Dubai’s coastal charm.
                    </i>
                  </b>
                </p>
              </div>
            </div>

            <div className="col-lg-6 my-auto" data-aos="fade-right">
              <div className="text-wrapper pe-lg-5">
                <h2 className="text-start">ANNIVERSARY EVENT</h2>
                <p>
                  <b>Celebrate your anniversary on a yacht rental in Dubai</b>
                </p>
                <p>
                  Ready to make your milestone in true Dubai style? Aboard a
                  luxury anniversary yacht in Dubai, where your special day
                  meets the open sea. With Blue Harbour, create the perfect
                  setting to celebrate your love with elegance and a touch of
                  Arabian charm.
                </p>
                <p>
                  Be it your first or fiftieth, a wedding anniversary on a yacht
                  in Dubai offers golden sunsets, skyline views, and private
                  dining beneath the stars. Our luxury yachts feature curated
                  decor, gourmet cuisines, and a friendly crew that handles
                  every detail expertly. Make your anniversary on a yacht as
                  timeless as the city itself! Think candlelight, calm waters,
                  soothing music and the stunning glow of the Burj Khalifa in
                  the distance.
                </p>
                <p>
                  <b>
                    <i>
                      Sail into another year of love- the Dubai way, with Blue
                      Harbour, your partner for luxury yacht rental Dubai.
                    </i>
                  </b>
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="assets/images/Marriage-Proposal-1.webp" alt="" />
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Events;
